/**
 * UI Library i18n exports
 *
 * This module exports translation resources for all UI library components.
 * Consuming apps should merge these resources into their i18n configuration.
 */

import { transformFeatureToLanguage } from './utils/transformResources'
import uiTranslations from './translations/ui.json'
import gwrTranslations from './translations/gwr.json'

// Transform the feature-based format to i18next standard format
const transformedTranslations = transformFeatureToLanguage(uiTranslations)
const transformedGwrTranslations = transformFeatureToLanguage(gwrTranslations)

/**
 * UI library translation resources
 *
 * Usage in consuming apps:
 * ```typescript
 * import { uiResources } from '@popety-io/ui'
 * import { mergeDeep } from './utils'
 *
 * const resources = mergeDeep(appResources, uiResources)
 * i18next.init({ resources })
 * ```
 */
export const uiResources = {
  en: { ui: transformedTranslations.en, gwr: transformedGwrTranslations.en },
  fr: { ui: transformedTranslations.fr, gwr: transformedGwrTranslations.fr },
  de: { ui: transformedTranslations.de, gwr: transformedGwrTranslations.de },
  it: { ui: transformedTranslations.it, gwr: transformedGwrTranslations.it },
}

// Re-export useTranslation for library components
export { useTranslation } from 'react-i18next'
